export var DATABASE = 'application/x-slite-database';
export var DATABASE_COLUMN = 'application/x-slite-database-column';
export var DATABASE_FIELD = 'application/x-slite-database-field';
export var DATABASE_ROW = 'application/x-slite-database-row';
export var TEXT_PLAIN = 'text/plain';
export default {
  DATABASE: DATABASE,
  DATABASE_COLUMN: DATABASE_COLUMN,
  DATABASE_FIELD: DATABASE_FIELD,
  DATABASE_ROW: DATABASE_ROW,
  TEXT_PLAIN: TEXT_PLAIN
};